(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mh-cro-product"] && !Shopify.designMode) return;
  try {
    (() => {
  let scheduled = false;
  function sync() {
    scheduled = false;
    const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
    const bar = document.querySelector('#bundle-sticky_add_to_cart .Vtl-StickyAddToCart__Container');
    if (!productInfo || !bar) return;
    const price = productInfo.querySelector('[id^="price-"] .price');
    const amount = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price-item--regular');
    if (!amount) return;
    let label = bar.querySelector('.mh-cro-sticky-price');
    if (!label) {
      label = document.createElement('span');
      label.className = 'mh-cro-sticky-price';
      label.setAttribute('aria-live', 'polite');
      bar.prepend(label);
    }
    const value = amount.textContent.trim();
    if (label.textContent !== value) label.textContent = value;
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(sync); }
  }
  function connect() {
    const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
    if (!productInfo) return;
    new MutationObserver(schedule).observe(productInfo, {subtree: true, childList: true, characterData: true});
    const watch = new MutationObserver(() => {
      const root = document.getElementById('sticky_add_to_cart_root');
      if (!root) return;
      watch.disconnect();
      new MutationObserver(schedule).observe(root, {subtree: true, childList: true});
      schedule();
    });
    const root = document.getElementById('sticky_add_to_cart_root');
    if (root) new MutationObserver(schedule).observe(root, {subtree: true, childList: true});
    else watch.observe(document.body, {childList: true});
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, {once: true});
  else connect();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mh-product-availability"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mh-order-timeline')) {
  customElements.define('mh-order-timeline', class extends HTMLElement {
    connectedCallback() { this.updateDates(); }
    updateDates() {
      const valid = value => /^\d{4}-\d{2}-\d{2}$/.test(value || '');
      const format = value => new Intl.DateTimeFormat(this.dataset.locale || 'es', {timeZone:'UTC',weekday:'long',day:'numeric',month:'long'}).format(new Date(value+'T12:00:00Z'));
      const next = this.dataset.nextDispatchDate;
      const intro = this.querySelector('[data-promise-intro]');
      const date = this.querySelector('[data-next-date]');
      if (date) {
        intro.hidden = !valid(next);
        date.textContent = valid(next) ? format(next) : this.dataset.availabilityLoaded === 'true' ? this.dataset.noDates : this.dataset.loading;
      }
      const selected = this.dataset.requestedDate;
      const label = this.querySelector('[data-selected-date]');
      label.parentElement.hidden = !valid(selected);
      label.textContent = valid(selected) ? format(selected) : '';
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
